
















import Header from './components/Header.vue'
import BasePage from '@/components/layout/BasePage.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
// import VideoUpdatesModal from '@/views/app/management/settings/components/VideoUpdatesModal.vue'
// import { IUpdatesVideoConfig } from '@/interfaces/UpdatesVideo'
// import { User } from '@/classes/User'
// import Api from '@/api'
// import { EViewedUpdate } from '@zunta/configurations'
// import { UserModule } from '@/store/modules/user.module'
// import { getModule } from 'vuex-module-decorators'
//
// const videoLocalToDBModules: any = {
//   'management-settings': EViewedUpdate.NEW_IN_SETTINGS
// }
//
// // key - is a route name
// const videoRoutes: any = {
//   'management-settings': {
//     videoUrl: '',
//     moduleViewed: videoLocalToDBModules['management-settings'],
//     htmlContent: ''
//   }
// }

@Component({
  components: {
    // VideoUpdatesModal,
    BasePage,
    Header
  }
})
export default class Management extends Vue {
  // userInstanceModule: UserModule = getModule(UserModule, this.$store);
  // user: User = Api.getUser() as User

  // showVideo: boolean = false
  // videoConfig: IUpdatesVideoConfig = videoRoutes['management-settings']

  // async mounted () {
  //   const res = await this.userInstanceModule.getViewedVideoModule(this.user.data.id)
  //
  //   if (res && res.viewedUpdates) {
  //     this.$cookies.set('viewed-updates-video', res.viewedUpdates)
  //   }
  //
  //   this.$watch('$route', (value: any, oldValue: any) => {
  //     if (oldValue && oldValue.name === value.name) {
  //       return
  //     }
  //
  //     let parentAndCurrentRoutes: string[] = [value.name]
  //
  //     const routeHasParent: boolean = value.matched[value.matched.length - 1] && value.matched[value.matched.length - 1].parent
  //     if (routeHasParent) {
  //       parentAndCurrentRoutes.push(value.matched[value.matched.length - 1].parent.name)
  //     }
  //
  //     // @ts-ignore
  //     const routeWithVideo: string | undefined = parentAndCurrentRoutes.find((routeName: string) => !!videoRoutes[routeName])
  //     if (!routeWithVideo) {
  //       return
  //     }
  //
  //     let viewedModules: string[] = this.$cookies.get('viewed-updates-video') || []
  //     viewedModules = [...this.user.getViewedUpdatesVideos(), ...viewedModules]
  //     // @ts-ignore
  //     const showVideo = !!videoLocalToDBModules[routeWithVideo] && !viewedModules.includes(videoLocalToDBModules[routeWithVideo])
  //     if (showVideo) {
  //       this.videoConfig = videoRoutes[routeWithVideo] as IUpdatesVideoConfig
  //       this.showVideo = true
  //     }
  //   }, { immediate: true })
  //
  //   this.$eventBus.$on('showUpdateVideo', (configKey: string) => {
  //     this.videoConfig = videoRoutes[configKey] as IUpdatesVideoConfig
  //     this.showVideo = true
  //   })
  // }

  // beforeDestroy () {
  //   this.$eventBus.$off('showUpdateVideo')
  // }
}
